import { render } from "./App.vue?vue&type=template&id=951bb88c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=951bb88c&lang=sass"
import "./App.vue?vue&type=style&index=1&id=951bb88c&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__